export function groupBy<T, TK>(list: T[], keyGetter: (obj: T) => TK): Map<TK, T[]> {
  const map = new Map<TK, T[]>();
  list.forEach((item) => {
    const key: TK = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

export function groupByValues<T, TK>(list: T[], keyGetter: (obj: T) => TK): Array<Array<T>> {
  const map = new Map<TK, T[]>();
  list.forEach((item) => {
    const key: TK = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });

  let array1 = new Array<Array<T>>();
  for (let mapElement of map.values()) {
    let array = new Array<T>();
    for (let mapElementElement of mapElement.values()) {
      array.push(mapElementElement)
    }
    array1.push(array);
  }
  return array1;
}

export function distinctBy<T, TK>(list: T[], keyGetter: (obj: T) => TK): T[] {
  return list.filter((thing, i, arr) => {
    return arr.indexOf(arr.find(t => keyGetter(t) === keyGetter(thing))) === i;
  }).filter(value => value != null);
}

export function sumOf<T>(list: T[], keyGetter: (obj: T) => number): number {
  return list.reduce((a: number, b: T) => {
    const number1 = keyGetter(b) || 0;
    return a + number1;
  }, 0);
}

export function minOf<T>(list: T[], keyGetter: (obj: T) => number): number {
  let len = list.length, min = Infinity;
  while (len--) {
    const number1 = keyGetter(list[len]);
    if (number1 < min) {
      min = number1;
    }
  }
  return min;
}

export function maxOf<T>(list: T[], keyGetter: (obj: T) => number): number {
  let len = list.length, max = -Infinity;
  while (len--) {
    const number1 = keyGetter(list[len]);
    if (number1 > max) {
      max = number1;
    }
  }
  return max;
}
